module.exports = __webpack_public_path__ + "media/assets/images/flags/id-92840024040f98cc4683af445f8e1e3d.svg";